export default __webpack_public_path__ + "2f34af3c11b46c0e56ffeaaabd9d8e4c.png";